import classNames from 'classnames';
import { forwardRef, MouseEvent, ReactNode } from 'react';

import classes from './ShadowBox.module.scss';

interface ShadowBoxProps {
  className?: string;
  onClick?: (e?: MouseEvent<HTMLDivElement>) => void;
  children: ReactNode;
}

const ShadowBox = forwardRef<HTMLDivElement, ShadowBoxProps>(
  ({ className, children, onClick }, ref) => {
    return (
      <div
        ref={ref}
        onClick={onClick}
        className={classNames(classes.Container, className)}
      >
        {children}
      </div>
    );
  }
);
ShadowBox.displayName = 'Shadow box';

export default ShadowBox;
